import { Action } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from './Reducers';
import store from './store';

export type AppDispatch = typeof store.dispatch
export type AppActions = Action<AppActions>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
